export const TrpcURL = {
  fullPath: 'trpcApi',
};
